/**
 * Estado de la vista previa "Ver como".
 *
 * Vive fuera de React porque lo necesitan tanto los componentes como las capas de
 * red (interceptor de axios y `prepareHeaders` de RTK Query), que no pueden usar
 * hooks. Un `CustomEvent` mantiene sincronizada a la interfaz.
 *
 * El servidor es quien manda: estas cabeceras solo *piden* la vista previa, y
 * `middleware/viewAs.js` decide si la concede — nunca escala permisos y solo
 * permite lecturas.
 */
const KEY = 'viewAs';
export const VIEW_AS_EVENT = 'viewas:change';

/** `{ role, zone } | null` */
export function getViewAs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.role ? parsed : null;
  } catch {
    return null;
  }
}

export function setViewAs(next) {
  try {
    if (next && next.role) localStorage.setItem(KEY, JSON.stringify(next));
    else localStorage.removeItem(KEY);
  } catch { /* almacenamiento no disponible */ }
  window.dispatchEvent(new CustomEvent(VIEW_AS_EVENT, { detail: next || null }));
}

export const clearViewAs = () => setViewAs(null);

/** Cabeceras a añadir a una petición. Vacío si no hay vista previa. */
export function viewAsHeaders() {
  const v = getViewAs();
  if (!v) return {};
  const headers = { 'X-View-As-Role': v.role };
  if (v.zone) headers['X-View-As-Zone'] = v.zone;
  return headers;
}
